var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUndrawChatWithAiIr62(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 800.597,
    height: 566.88,
    viewBox: "0 0 800.597 566.88",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-526.81 -263.328)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M501.444,232.117a4.94,4.94,0,0,0-2.033.885,6.952,6.952,0,0,0-1.651,1.734,8.749,8.749,0,0,0-1.113,2.334,9.164,9.164,0,0,0-.413,2.69V614.065a9.473,9.473,0,0,0,1.522,5.11A7.565,7.565,0,0,0,499.408,621a5.267,5.267,0,0,0,2.034,1l277.323,64.009a8.166,8.166,0,0,0,3.389.092,6.584,6.584,0,0,0,2.782-1.238,6.385,6.385,0,0,0,1.884-2.359,7.649,7.649,0,0,0,.694-3.261V191.186a7.917,7.917,0,0,0-.694-3.3,6.927,6.927,0,0,0-1.884-2.466,7.027,7.027,0,0,0-2.781-1.4,8.173,8.173,0,0,0-3.389-.1Z",
    transform: "translate(307.983 79.54)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.591,240.989a5.076,5.076,0,0,0-2.07.92,7.058,7.058,0,0,0-1.672,1.772,8.805,8.805,0,0,0-1.11,2.373,9.189,9.189,0,0,0-.386,2.729V607.174a9.525,9.525,0,0,0,1.5,5.192,7.712,7.712,0,0,0,1.672,1.873,5.437,5.437,0,0,0,2.07,1.044L767.1,673.154a7.926,7.926,0,0,0,3.342,0,6.427,6.427,0,0,0,4.54-3.727,7.821,7.821,0,0,0,.635-3.285v-459.9a8.092,8.092,0,0,0-.635-3.323,6.983,6.983,0,0,0-4.54-4,7.969,7.969,0,0,0-3.342-.2Z",
    transform: "translate(308.24 80.163)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.279,286.895a2.3,2.3,0,0,0-.981.354,3.019,3.019,0,0,0-.8.758,3.725,3.725,0,0,0-.539,1.053,3.983,3.983,0,0,0-.2,1.238v14.348a3.632,3.632,0,0,0,.2,1.2,2.916,2.916,0,0,0,.538.943,2.265,2.265,0,0,0,.8.6,1.994,1.994,0,0,0,.981.16l174.8-15.421a3.53,3.53,0,0,0,1.355-.413,3.967,3.967,0,0,0,1.109-.888,4.189,4.189,0,0,0,.75-1.238,4.056,4.056,0,0,0,.278-1.456V271.187a3.63,3.63,0,0,0-.276-1.4,3.211,3.211,0,0,0-.75-1.092,3.017,3.017,0,0,0-1.109-.67,3.152,3.152,0,0,0-1.358-.146Z",
    transform: "translate(309.684 83.068)",
    fill: "#F50057"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.3,332.315a.549.549,0,0,0-.248.077.7.7,0,0,0-.2.18.882.882,0,0,0-.135.257.976.976,0,0,0-.05.307v5.607a.923.923,0,0,0,.049.3.764.764,0,0,0,.135.241.594.594,0,0,0,.2.157.506.506,0,0,0,.248.049l177.921-9.644a.863.863,0,0,0,.34-.091.945.945,0,0,0,.277-.213,1,1,0,0,0,.256-.666v-6.61a.932.932,0,0,0-.069-.355.855.855,0,0,0-.187-.281.8.8,0,0,0-.618-.233Z",
    transform: "translate(309.722 85.315)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.3,349.685a.541.541,0,0,0-.248.073.685.685,0,0,0-.2.177.863.863,0,0,0-.135.254.967.967,0,0,0-.049.306V356.1a.932.932,0,0,0,.049.3.779.779,0,0,0,.135.248.611.611,0,0,0,.2.16.513.513,0,0,0,.248.053l177.921-6.411a.852.852,0,0,0,.34-.083.92.92,0,0,0,.277-.208.981.981,0,0,0,.256-.66V342.89a.942.942,0,0,0-.069-.356.876.876,0,0,0-.187-.285.825.825,0,0,0-.277-.186.813.813,0,0,0-.34-.058Z",
    transform: "translate(309.722 86.18)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.3,367.057a.534.534,0,0,0-.248.068.67.67,0,0,0-.2.173.843.843,0,0,0-.135.252.957.957,0,0,0-.049.305v5.607a.94.94,0,0,0,.05.3.8.8,0,0,0,.134.248.628.628,0,0,0,.2.165.518.518,0,0,0,.248.058l177.918-3.171a.841.841,0,0,0,.34-.083.9.9,0,0,0,.277-.2.951.951,0,0,0,.187-.3.974.974,0,0,0,.068-.36v-6.608a.949.949,0,0,0-.068-.357.9.9,0,0,0-.187-.288.846.846,0,0,0-.277-.195.82.82,0,0,0-.34-.061Z",
    transform: "translate(309.722 87.044)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.993,401.833a.52.52,0,0,0-.248.059.632.632,0,0,0-.2.165.8.8,0,0,0-.132.248.943.943,0,0,0-.049.3v5.6a.953.953,0,0,0,.049.305.837.837,0,0,0,.135.248.661.661,0,0,0,.2.172A.531.531,0,0,0,538,409l177.8,3.3a.826.826,0,0,0,.339-.066.852.852,0,0,0,.277-.192.907.907,0,0,0,.187-.29.958.958,0,0,0,.069-.357v-6.606a.972.972,0,0,0-.069-.36.942.942,0,0,0-.187-.3.888.888,0,0,0-.277-.2.836.836,0,0,0-.339-.077Z",
    transform: "translate(309.71 88.69)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.993,419.33a.514.514,0,0,0-.248.054.615.615,0,0,0-.2.165.789.789,0,0,0-.135.248.929.929,0,0,0-.047.3v5.6a.964.964,0,0,0,.05.306.853.853,0,0,0,.135.253.678.678,0,0,0,.2.175.539.539,0,0,0,.248.071l177.8,6.53a.815.815,0,0,0,.339-.06.83.83,0,0,0,.277-.187.883.883,0,0,0,.187-.286.947.947,0,0,0,.068-.357v-6.608a.981.981,0,0,0-.068-.361.965.965,0,0,0-.187-.3.909.909,0,0,0-.277-.206.846.846,0,0,0-.339-.083Z",
    transform: "translate(309.71 89.424)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.993,436.824a.507.507,0,0,0-.245.053.6.6,0,0,0-.2.156.768.768,0,0,0-.135.242.923.923,0,0,0-.05.3v5.6a.969.969,0,0,0,.05.307.871.871,0,0,0,.135.256.7.7,0,0,0,.2.178A.546.546,0,0,0,538,444l177.8,9.765a.8.8,0,0,0,.617-.236.864.864,0,0,0,.187-.283.937.937,0,0,0,.069-.355v-6.608a.991.991,0,0,0-.256-.66.935.935,0,0,0-.277-.21.857.857,0,0,0-.339-.089Z",
    transform: "translate(309.71 90.159)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.993,454.407a.5.5,0,0,0-.248.045.583.583,0,0,0-.2.155.75.75,0,0,0-.135.239.918.918,0,0,0-.05.3v5.6a.98.98,0,0,0,.05.308.9.9,0,0,0,.135.258.714.714,0,0,0,.2.182.554.554,0,0,0,.248.083l177.8,13.014a.8.8,0,0,0,.339-.048.789.789,0,0,0,.277-.177.842.842,0,0,0,.187-.279.926.926,0,0,0,.068-.354v-6.609a1,1,0,0,0-.068-.363,1.018,1.018,0,0,0-.187-.305.962.962,0,0,0-.277-.216.87.87,0,0,0-.339-.095Z",
    transform: "translate(309.71 90.896)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.993,471.9a.5.5,0,0,0-.248.041.57.57,0,0,0-.2.153.733.733,0,0,0-.135.234.907.907,0,0,0-.05.3v5.6a.991.991,0,0,0,.05.309.913.913,0,0,0,.134.261.735.735,0,0,0,.2.186.563.563,0,0,0,.248.083l177.8,16.254a.8.8,0,0,0,.339-.041.772.772,0,0,0,.277-.172.826.826,0,0,0,.187-.276.919.919,0,0,0,.068-.353v-6.609a1.011,1.011,0,0,0-.068-.365,1.039,1.039,0,0,0-.187-.309.986.986,0,0,0-.277-.221.88.88,0,0,0-.339-.1Z",
    transform: "translate(309.71 91.631)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.993,506.982a.5.5,0,0,0-.248.032.54.54,0,0,0-.2.139.7.7,0,0,0-.135.236.894.894,0,0,0-.05.3v5.6a1.006,1.006,0,0,0,.05.31.953.953,0,0,0,.135.266.776.776,0,0,0,.2.193.583.583,0,0,0,.248.093l177.8,22.738a.785.785,0,0,0,.339-.029.734.734,0,0,0,.277-.165.782.782,0,0,0,.187-.269.9.9,0,0,0,.068-.35v-6.606a1.03,1.03,0,0,0-.068-.367,1.089,1.089,0,0,0-.187-.315,1.04,1.04,0,0,0-.277-.231.909.909,0,0,0-.339-.114Z",
    transform: "translate(309.71 93.103)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.993,524.477a.487.487,0,0,0-.248.028.528.528,0,0,0-.2.14.682.682,0,0,0-.135.229.887.887,0,0,0-.05.3v5.6a1.011,1.011,0,0,0,.049.311.974.974,0,0,0,.135.268.8.8,0,0,0,.2.2.591.591,0,0,0,.248.1l177.8,25.974a.784.784,0,0,0,.339-.023.719.719,0,0,0,.277-.157.761.761,0,0,0,.187-.266.891.891,0,0,0,.068-.349V550.22a1.041,1.041,0,0,0-.068-.368,1.119,1.119,0,0,0-.187-.319,1.076,1.076,0,0,0-.277-.236.927.927,0,0,0-.339-.12Z",
    transform: "translate(309.71 93.837)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.993,541.973a.483.483,0,0,0-.248.023.513.513,0,0,0-.2.136.665.665,0,0,0-.135.227.878.878,0,0,0-.05.3v5.605a1.021,1.021,0,0,0,.05.313,1,1,0,0,0,.135.271.818.818,0,0,0,.2.2.606.606,0,0,0,.248.1l177.8,29.209a.781.781,0,0,0,.339-.016.7.7,0,0,0,.277-.152.743.743,0,0,0,.187-.263.883.883,0,0,0,.068-.348v-6.61a1.049,1.049,0,0,0-.068-.37,1.146,1.146,0,0,0-.187-.323,1.1,1.1,0,0,0-.277-.241.943.943,0,0,0-.339-.126Z",
    transform: "translate(309.71 94.571)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1121.847 406.71)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M671.114,263.4h74.855v-1.062H672.176V212.961h-1.062Z",
    transform: "translate(-654.549 -153.968)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.176,302.4h-1.062V251.961h74.855v1.062H354.176Z",
    transform: "translate(-322.414 -97.359)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.969,90.4H420.114V39.961h1.062V89.333h73.793Z",
    transform: "translate(-364.264 -18.746)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.059,154.52a1.516,1.516,0,0,0,0,3.032h30.748a1.516,1.516,0,1,0,0-3.032Z",
    transform: "translate(-528.104 -154.52)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.059,171.342a1.516,1.516,0,0,0,0,3.032h30.748a1.516,1.516,0,1,0,0-3.032Z",
    transform: "translate(-528.104 -162.411)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M959.539,352.015a1.516,1.516,0,0,1,0-3.032H990.29a1.516,1.516,0,1,1,0,3.032Z",
    transform: "translate(-958.023 -299.81)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M959.539,335.191a1.516,1.516,0,0,1,0-3.032H990.29a1.516,1.516,0,1,1,0,3.032Z",
    transform: "translate(-958.023 -291.918)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M723.26,390.09a56.8,56.8,0,1,1,56.8-56.8A56.8,56.8,0,0,1,723.26,390.09Zm0-112.548A55.743,55.743,0,1,0,779,333.285,55.743,55.743,0,0,0,723.26,277.542Z",
    transform: "translate(-574.505 -211.733)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.371,
    cy: 6.371,
    rx: 6.371,
    ry: 6.371,
    transform: "translate(119.556 65.278)",
    fill: "#F50057"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.371,
    cy: 6.371,
    rx: 6.371,
    ry: 6.371,
    transform: "translate(97.592 149.293)",
    fill: "#F50057"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.371,
    cy: 6.371,
    rx: 6.371,
    ry: 6.371,
    transform: "translate(87.172 103.056)",
    fill: "#F50057"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.769,514.267a1.516,1.516,0,1,0,0,3.031H532.52a1.516,1.516,0,1,0,0-3.031Z",
    transform: "translate(-486.118 -302.443)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.769,531.091a1.516,1.516,0,1,0,0,3.032H532.52a1.516,1.516,0,1,0,0-3.031Z",
    transform: "translate(-486.118 -310.335)",
    fill: "#2f2e41"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(526.81 479.266)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M181.935.683,0,.247v-1l181.935.436Z",
    transform: "translate(0 350.259)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.856,322.828l-9.115-17.966-10.488,5.322,9.115,17.966a12.345,12.345,0,0,0,.866,9.5c2.841,5.6,8.9,8.232,13.536,5.881s6.087-8.8,3.246-14.4a12.345,12.345,0,0,0-7.16-6.311Z",
    transform: "translate(-25.49 -157.182)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.68,203.788l46.052,86.07,18.007-9.631L113.4,192.033",
    transform: "translate(-4.18 -119.362)",
    fill: "#F50057"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.269,240.057,118.82,298.35l-54.7,1.911s7.167-40.486,4.623-47.483Z",
    transform: "translate(4.387 -135.459)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12.783,
    height: 16.848,
    transform: "translate(121.106 321.532)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.46,596.61a4.181,4.181,0,0,1-1.754-2.938,5.35,5.35,0,0,1,1.81-3.882c.031-.391.429-5.234,1.315-6.1a4.206,4.206,0,0,1,.214-3.094,2.152,2.152,0,0,1,1.67-.911l.033,0,.017.029c.022.038,2.178,3.785,5.424,4.114,1.86.191,3.723-.768,5.536-2.845.064-.154.577-2.683.908-4.358l.013-.067,17.68,9.293,10.334,2.86a3.008,3.008,0,0,1,.5,5.611l-5.009,2.408a15.672,15.672,0,0,1-6.749,1.538H143.23a7.588,7.588,0,0,1-4.77-1.651Z",
    transform: "translate(-19.941 -248.254)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12.783,
    height: 16.848,
    transform: "translate(44.366 333.594) rotate(-163.78)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.919,584.7a4.181,4.181,0,0,1-.864-3.313,5.345,5.345,0,0,1,2.822-3.222c.139-.367,1.874-4.906,2.967-5.492a4.2,4.2,0,0,1,1.07-2.911,2.152,2.152,0,0,1,1.858-.408l.032.006.008.033c.01.042,1.035,4.242,4.058,5.465,1.734.7,3.789.3,6.11-1.186.105-.127,1.3-2.415,2.089-3.931l.031-.064,14.382,13.866,9.124,5.633a3.008,3.008,0,0,1-1.083,5.527l-5.483.913a15.674,15.674,0,0,1-6.91-.408L5.041,587.62A7.589,7.589,0,0,1,.922,584.7Z",
    transform: "translate(25.901 -245.82)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.236,286.03l54.7,1.274s33.241,95.818,31.969,186.775H81.276L78.566,368.49,70.64,478.18l-60.134-3.463Z",
    transform: "translate(22.359 -150.87)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.974,114.569a20.782,20.782,0,1,0-32.258,17.322,51.59,51.59,0,0,1-6.8,11.993L94.4,160.95,98.415,134.4a20.79,20.79,0,0,0,14.559-19.833Z",
    transform: "translate(1.942 -86.427)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.88,166.988l-23.535-5.725L52.26,180.579A31.1,31.1,0,0,0,50.681,204.1L63.19,241.633s38.165-.637,46.434-22.9l2.371-4.939a20.323,20.323,0,0,0-1.911-20.782Z",
    transform: "translate(9.429 -109.047)",
    fill: "#F50057"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.457,346.222l.437-20.14-11.759-.255-.437,20.14a12.345,12.345,0,0,0-3.72,8.792c-.136,6.278,3.965,11.458,9.161,11.571s9.519-4.888,9.653-11.166a12.346,12.346,0,0,0-3.335-8.942Z",
    transform: "translate(8.801 -164.21)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.854,204.882V302.5H70.275l6.036-96.794",
    transform: "translate(9.17 -123.668)",
    fill: "#F50057"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.163,113.934S95.531,108.5,91.5,102.339c0,0,17.373,3.026,17.821,0s0-22.417-23.537-19.278-20.4,22.864-20.4,22.864,1.72,19.069,14.384,22.992C79.765,128.918,69.972,110.012,79.163,113.934Z",
    transform: "translate(4.011 -82.719)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.145,98.67s-4.834-3.491-10.472-2.416c-1.975.376-4.062,1.821-5.944,3.54A32.929,32.929,0,0,0,37.3,112.436c-4.929,12.92-15.274,45.238,2.824,49.2,22.69,4.969,24.1-43.029,24.1-43.029L62.145,98.671Z",
    transform: "translate(15.869 -87.187)",
    fill: "#090814"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.766, -0.643, 0.643, -0.766, 158.754, 187.688)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.691,34.4A1.593,1.593,0,0,1,.138,32.763l.136-5.469L0,27.27l.1-3.714.268.033L.853,4A2.762,2.762,0,0,1,3.325,1.323L15.781.011a2.091,2.091,0,0,1,2.3,2.221L16.2,30.127a2.587,2.587,0,0,1-2.181,2.38L1.988,34.375h0a1.593,1.593,0,0,1-.3.021Z",
    transform: "translate(0 0)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.042,30.008,3.72,30.99a.524.524,0,0,0-.44.461h0a.593.593,0,0,1-.5.522l-1.332.207A1.256,1.256,0,0,1,0,30.907l.685-28.4A1.435,1.435,0,0,1,1.993,1.111L14.44,0a1.108,1.108,0,0,1,1.2,1.17l-1.68,27.637a1.788,1.788,0,0,1-1.51,1.656l-1.4.218A.892.892,0,0,0,10.042,30.008Z",
    transform: "translate(1.29 1.484)",
    fill: "#F50057"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(698.508 586.962)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M476.795,235H401.232a3.368,3.368,0,0,0-3.363,3.363v30.264a3.367,3.367,0,0,0,3.363,3.363h5.341v10.879h.2a8.119,8.119,0,0,0,8.11-8.11V271.99h61.914a3.367,3.367,0,0,0,3.363-3.363V238.363A3.368,3.368,0,0,0,476.795,235Zm2.967,33.627a2.971,2.971,0,0,1-2.967,2.967H414.485v3.165a7.726,7.726,0,0,1-7.517,7.712V271.594h-5.736a2.971,2.971,0,0,1-2.967-2.967V238.363a2.971,2.971,0,0,1,2.967-2.967h75.562a2.971,2.971,0,0,1,2.967,2.967Z",
    transform: "translate(-397.87 -235)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.035,273.5H480.342a2.322,2.322,0,0,0-2.469,2,.571.571,0,0,0,0,.082,2.307,2.307,0,0,0,2.473,2.084h45.693a2.114,2.114,0,1,0,0-4.168Z",
    transform: "translate(-462.044 -264.842)",
    fill: "#F50057"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.035,315.5H480.342a2.322,2.322,0,0,0-2.469,2,.571.571,0,0,0,0,.082,2.307,2.307,0,0,0,2.473,2.084h45.693a2.114,2.114,0,1,0,0-4.168Z",
    transform: "translate(-462.044 -298.535)",
    fill: "#F50057"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.035,357.5H480.342a2.322,2.322,0,0,0-2.469,2,.571.571,0,0,0,0,.082,2.307,2.307,0,0,0,2.473,2.084h45.693a2.114,2.114,0,1,0,0-4.168Z",
    transform: "translate(-462.044 -332.227)",
    fill: "#F50057"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 35.722,
    cy: 35.722,
    r: 35.722,
    transform: "translate(1236.71 492.087)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M977.659,395.925c-3.817-.435-6.773-4.092-7.1-7.8-.386-4.414,2.185-8.607,5.711-11.084a24.384,24.384,0,0,1,12.73-3.91,34.986,34.986,0,0,1,23.914,7.882c3.332,2.767,6.443,6.292,7.622,10.549a10.218,10.218,0,0,1-2.783,10.476,7.03,7.03,0,0,1-5.395,1.661,13.407,13.407,0,0,1-6.279-2.793c-3.585-2.606-6.528-6.237-10.9-7.6-3.2-1-7.358-.12-9.315,2.776a5.27,5.27,0,0,0-.842,2.208.684.684,0,0,0,.461.812.664.664,0,0,0,.812-.461c.514-3.647,5-5.009,8.146-4.176,4.589,1.215,7.669,5.309,11.434,7.911a13.9,13.9,0,0,0,6.659,2.658,8.269,8.269,0,0,0,5.81-1.785,11.3,11.3,0,0,0,3.735-10.841c-.824-4.554-3.889-8.458-7.252-11.48a36.278,36.278,0,0,0-24.792-9.159,27.124,27.124,0,0,0-13.515,3.526,14.76,14.76,0,0,0-7.286,11.015,10.4,10.4,0,0,0,5.605,10.142,8.778,8.778,0,0,0,2.813.794C978.5,397.341,978.495,396.02,977.659,395.925Z",
    transform: "translate(276.688 139.4)",
    fill: "#3f3d56"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndrawChatWithAiIr62);
export default __webpack_public_path__ + "static/media/undraw_chat-with-ai_ir62.6ca491d46353e8a63c1ca9e8197bfe3d.svg";
export { ForwardRef as ReactComponent };